import { Typography } from "@mui/material"
import AppTextField from "components/StyledComponents/AppTextField"
import { FieldArray } from "formik"
import React from "react"
import { Col, Row } from "react-bootstrap"
import ClearIcon from "@mui/icons-material/Clear"
import { useTheme } from "@mui/system"
import StyledLabel from "components/StyledComponents/StyledLabel"

const AddUniqueFact = ({
  formik,
  values,
  name,
  buttonText,
  label,
  placeholder = "Enter Unique Fact",
  fullWidth = false
}) => {
  const theme = useTheme()
  // Guard against a non-array value (e.g. an empty string from a form's initial
  // values) so the FieldArray render never throws "values.map is not a function".
  const items = Array.isArray(values) ? values : []

  return (
    <Row className="w-100 m-0 mt-4">
      <StyledLabel variant={fullWidth ? "body1Regular" : undefined}>{label}</StyledLabel>
      <FieldArray
        name={name}
        render={(arrayHelper) => (
          <>
            {items.map((fact, index) => {
              const inputEl = (
                <AppTextField
                  id={`${name}-${index}`}
                  name={`${name}[${index}].fact`}
                  type="text"
                  fullWidth
                  placeholder={placeholder}
                  value={fact?.fact || ""}
                  onChange={(event) => {
                    formik.setFieldValue(`${name}[${index}].fact`, event.target.value)
                  }}
                  onBlur={formik.handleBlur(`${name}[${index}].fact`)}
                  error={Boolean(formik.errors?.[name]?.[index]?.fact)}
                  helperText={formik.errors?.[name]?.[index]?.fact || ""}
                />
              )
              const removeEl = index > 0 && (
                <span role="button" onClick={() => arrayHelper.remove(index)}>
                  <ClearIcon sx={{ width: "30px", height: "48px" }} />
                </span>
              )
              // fullWidth: flex layout so the input fills the full column width
              // (the remove icon sits beside it without shrinking the box like the grid does).
              return fullWidth ? (
                <div
                  className={`d-flex align-items-start${index === 0 ? "" : " mt-2"}`}
                  style={{ gap: 8 }}
                  id={`${name}-${index}`}
                  key={`${name}-${index}`}>
                  <div style={{ flex: 1, minWidth: 0 }}>{inputEl}</div>
                  {/* Reserve the remove-icon slot only when there are multiple rows: a
                      single row spans full width (like the other fields), while multi-row
                      groups still align to the same edges. */}
                  {items.length > 1 && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 50,
                        flex: "0 0 30px"
                      }}>
                      {removeEl}
                    </span>
                  )}
                </div>
              ) : (
                <Row
                  className="mt-2"
                  style={{ paddingRight: 0 }}
                  id={`${name}-${index}`}
                  key={`${name}-${index}`}>
                  <Col lg="11">{inputEl}</Col>
                  {index > 0 && (
                    <Col lg="1" style={{ display: "flex", justifyContent: "center" }}>
                      {removeEl}
                    </Col>
                  )}
                </Row>
              )
            })}
            <Row className="w-100 m-0 mt-2 justify-content-end">
              <Col
                lg="12"
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}>
                <Typography
                  variant="body1Regular"
                  onClick={() =>
                    arrayHelper.push({
                      fact: ""
                    })
                  }
                  sx={{
                    color: theme.palette.secondary.main,
                    textDecoration: "underline",
                    cursor: "pointer",
                    textUnderlineOffset: "2px"
                  }}>
                  {buttonText}
                </Typography>
              </Col>
            </Row>
          </>
        )}
      />
    </Row>
  )
}

export default AddUniqueFact
